import { useContext, useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import Templates from './template/Templates';
import './components/core/axios/Interceptor';
import { AppContext } from './components/context/AppContect';
import { Helmet } from 'react-helmet';
import './App.css';
import { ToastContainer } from 'react-toastify';
import { GeolocationProvider } from './components/context/GeoLocationContext';
import { ViewportHeightProvider } from './components/common/viewport-height-provider/ViewportHeightProvider';

function App() {
    const appContect = useContext(AppContext);

    return (
        <Provider store={store}>
            <Helmet>
                <title>Visitor-Dashboard</title>
            </Helmet>
            {/* <ViewportHeightProvider
                enabled={true}
                debounceDelay={100}
                passive={true}
                applyViewportClasses={false}
            > */}
            <GeolocationProvider>
                <AppContext.Provider value={appContect}>
                    <div className="App">
                        <ToastContainer toastStyle={{ animationDuration: '4000' }} position="top-right" />
                        <Templates />
                    </div>
                </AppContext.Provider>
            </GeolocationProvider>
            {/* </ViewportHeightProvider> */}
        </Provider>
    );
}

export default App;
